import React from 'react';
import { CreativeEmptyState } from './CreativeEmptyState';
import EmptyStateIcon from '../../../../resources/icons/creatives/explore_empty_state.svg';

const TRANSLATION_PREFIX = 'STATIC.PAGES.CREATIVE_EXPLORE.EMPTY_STATE';

export const CreativeExploreEmptyState = () => (
    <CreativeEmptyState
        title={`${TRANSLATION_PREFIX}.TITLE`}
        stepsCount={3}
        stepsPrefix={`${TRANSLATION_PREFIX}.STEPS`}
        icon={<EmptyStateIcon />}
    />
);
